import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import WallPoster from "./assets/WallPoster.png";
import MarketingHeader from "./component/MarketingHeader";
import Header from "./component/Header";
import Home from "./pages/Home/Home";
import ProductList from "./pages/Products/ProductList";
import MyAccount from "./pages/MyAccount/MyAccount";
import Profile from "./pages/MyAccount/Profile";
import Address from "./pages/MyAccount/Address";
import Login from "./component/Login"
import SignUp from "./component/SignUp";
import ProductInfo from "./pages/Products/components/ProductInfo";
import Footer from "./component/footer";
import ForgetPassword from "./component/Forgetpass";
import Women from "./pages/women";
import Contact from "./pages/Contact/contact";
import Order from "./pages/MyAccount/Order/Order.jsx";
import ProductDesc from "./pages/Products/components/ProductDescription";
import CheckOut from "./pages/CheckOut/CheckOut";
import Success from "./pages/CheckOut/Success";
import Cancel from "./pages/CheckOut/Cancel";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Customization from "./pages/Customization/customization";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./App.css";
import CategoryPage from './pages/Products/CategoryPage';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <div
          className="min-h-screen"
          style={{
            backgroundImage: `url(${WallPoster})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Toaster
            position="top-right"
            toastOptions={{
              success: {
                style: {
                  background: "#4CAF50",
                  color: "white",
                },
              },
              error: {
                style: {
                  background: "#EF4444",
                  color: "white",
                },
              },
              loading: {
                style: {
                  background: "#3B82F6",
                  color: "white",
                },
              },
            }}
          />
          <MarketingHeader />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/:categoryType" element={<ProductList />} />
              <Route path="/:categoryType/:categoryName" element={<ProductList />} />
              <Route path="/product/:productId" element={<ProductDesc />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/checkout" element={<CheckOut />} />
              <Route path="/success" element={<Success />} />
              <Route path="/customization" element={<Customization />} />
              <Route path="/cancel" element={<Cancel />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/account" element={<MyAccount />}>
                <Route index element={<Profile />} />
                <Route path="orders" element={<Order />} />
                <Route path="profile" element={<Profile />} />
                <Route path="address" element={<Address />} />
                
                  <Route path="forget-password" element={<ForgetPassword />} />
              </Route>
              <Route path="*" element={<div>404 - Page Not Found</div>} />
            </Routes>
          </main>
        </div>
        <Footer/>
      </Router>
    </Provider>
  );
}

export default App;
